import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import {
	antiFlashWhite,
	brandPrimaryText,
	brandSecondary,
	emailActivityTintColor,
	gray3,
	titles,
	white,
} from '../../../styles/colors';
import { CssSelectors, Layouts, cardStyle, truncateTextStyle } from '../../../styles/styles';

const {
	common: { border, borderRadius },
} = THEME;

export const styleSheet = StyleSheet.create({
	summaryBox: {
		height: 80,
	},
	body: {
		background: 'transparent !important',
		color: `${gray3} !important`,
		fontFamily: 'Sora !important',
		marginTop: 0,
		overflow: 'hidden',
	},
	card: {
		...cardStyle,
		border: 'none',
		borderRadius: 0,
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		boxSizing: 'border-box',
		color: brandPrimaryText,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	columnCard: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		overflow: 'hidden',
		padding: 16,
	},
	socialContainer: {
		...CssSelectors.allChildren(
			{
				marginBottom: 20,
				marginLeft: 20,
			},
			'button'
		),
		...CssSelectors.allDescendants(
			{
				border: `1px dashed ${brandSecondary}`,
				borderRadius: 3,
				boxSizing: 'border-box',
				fontSize: 14,
				padding: '1px 5px',
			},
			'span[data-placeholder="true"]'
		),
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
				maxWidth: 145,
			},
			'button'
		),
	},
	container: {
		alignItems: 'stretch',
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 14,
		padding: 0,
		position: 'relative',
		...CssSelectors.allChildren(
			{
				marginBottom: 20,
				marginLeft: 20,
			},
			'button'
		),
		...CssSelectors.allDescendants(
			{
				border: `1px dashed ${brandSecondary}`,
				borderRadius: 3,
				boxSizing: 'border-box',
				fontSize: 14,
				padding: '1px 5px',
			},
			'span[data-placeholder="true"]'
		),
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
				maxWidth: 145,
			},
			'button'
		),
	},
	containerPostShadow: {
		boxShadow: '10px 0px 6px rgba(139, 139, 139, 0.1)',
	},
	containerPost: {
		background: '#fff',
		border,
		borderRadius,
		boxSizing: 'border-box',
		marginLeft: 1,
		marginTop: 1,
		paddingLeft: 0,
		paddingRight: 0,
		paddingTop: 0,
	},
	flagHighlight: {
		borderBottom: 'none',
		borderLeft: 'none',
		height: 27,
		width: 27,
		zIndex: 5,
	},
	imageContainer: {
		alignItems: 'center',
		display: 'flex',
		height: 100,
		justifyContent: 'center',
		margin: 0,
		padding: 0,
		paddingRight: 3,
		paddingTop: 15,
		position: 'relative',
		width: 100,
		...CssSelectors.allChildren(
			{
				height: 100,
				left: 0,
				width: 100,
			},
			'img'
		),
		...CssSelectors.allChildren(
			{
				height: 100,
				left: 0,
				width: 100,
			},
			'video'
		),
	},
	imageFit: {
		objectFit: 'cover',
	},
	name: {
		borderTopLeftRadius: 9,
		borderTopRightRadius: 9,
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',

		fontSize: 14,
		paddingTop: 10,
		width: '100%',
		...truncateTextStyle,
	},
	personalCards: {
		height: 'calc(100% + 50px)',
		margin: 0,
		padding: '0 10px 10px',
	},
	popoverContainer: {
		display: 'flex',
		height: 28,
		maxWidth: '100%',
		paddingTop: 10,
		...CssSelectors.allChildren(
			{
				display: 'flex',
				height: 25,
				overflow: 'hidden',
				textOverflow: 'ellipsis',
			},
			'div'
		),
	},
	postName: {
		paddingLeft: 0,
		paddingTop: 2,
		width: '100%',
	},
	reviewed: {
		color: '#89C947',
	},
	select: {
		':not(:last-child)': {
			marginBottom: 10,
		},
		marginRight: 10,
		maxWidth: '100%',
		width: 'auto',
	},
	selectContainer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
	},
	selectedCard: {
		background: '#E8F3F9',
	},
	sideBarContainer: {
		alignItems: 'stretch',
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 14,
		padding: 0,
		position: 'relative',
	},
	socialIcon: {
		borderBottom: 'none',
		borderLeft: 'none',
		zIndex: 3,
	},
	socialIconContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		paddingBottom: 2,
	},
	socialIconContainerFlag: {
		display: 'flex',
		justifyContent: 'flex-end',
		paddingBottom: 0,
	},
	socialPopoverContainer: {
		marginLeft: 2,
		width: 120,
	},
	summaryPadding: {
		display: 'flex',
		padding: 15,
		paddingRight: 5,
		paddingTop: 0,
	},
	templateCard: {
		color: '#3F3F3F',
		paddingBottom: 20,
		width: '100%',
		...CssSelectors.allChildren(
			{
				color: brandPrimaryText,
			},
			'.campaign-template-card-name'
		),
	},
	templateCardContainer: {
		width: '100%',
	},
	templateCardDragging: {
		boxShadow: '0 0 10px 0 rgba(139,139,139,0.20)',
	},
	templateCards: {
		...Layouts.verticalStack(10),
		boxSizing: 'border-box',
		height: '100%',
		marginTop: 4,
		minHeight: 120,
		overflow: 'auto',
		paddingBottom: 10,
		paddingRight: 10,
	},
	templateCardsWithIndustrySelector: {
		boxSizing: 'border-box',
		height: `calc(100% - ${84}px)`,
	},
	textContainer: {},
	textContainerSmall: {
		fontSize: 12,
		height: 50,
		lineHeight: '16px',
		overflow: 'hidden',
		...CssSelectors.allDescendants({
			fontSize: 12,
		}),
	},
	textContentTwoLines: {
		display: '-webkit-box' as any,
		'-webkit-line-clamp': 2 as any,
		'-webkit-box-orient': 'vertical' as any,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		lineHeight: '1.4',
		height: 'auto',
		maxHeight: '2.8em', // 2 lines at 1.4 line-height
		fontSize: 12,
	},
	titleContainer: {
		display: 'flex',
		flexDirection: 'row-reverse',
	},

	trigger: {
		height: 40,
		padding: 0,
		paddingRight: 15,
	},
	triggerLabel: {
		borderRight: '1px solid rgb(216,216,216)',
		color: '#D1d1d1',
		fontSize: 12,
		letterSpacing: 1.1,
		paddingLeft: 10,
		paddingRight: 10,
		textTransform: 'uppercase',
		width: 160,
	},
	triggerText: {
		color: titles,
		paddingLeft: 10,
		width: '80%',
	},
	tooltipContent: {
		maxWidth: '300px',
		whiteSpace: 'normal',
		wordWrap: 'break-word',
	},
	// New styles for updated card components
	newCardContainer: {
		alignItems: 'stretch',
		background: white,
		border: `1px solid ${antiFlashWhite}`,
		borderRadius: 8,
		boxShadow: '0px 2px 8px rgba(139, 139, 139, 0.08)',
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		padding: 12,
		position: 'relative',
		transition: 'box-shadow 0.2s ease, transform 0.2s ease',
		':hover': {
			boxShadow: '0px 4px 16px rgba(139, 139, 139, 0.12)',
			transform: 'translateY(-1px)',
		},
	},
	newCardFeatured: {
		position: 'relative',
		':before': {
			content: '""',
			position: 'absolute',
			top: 0,
			right: 0,
			width: 0,
			height: 0,
			borderLeft: '20px solid transparent',
			borderTop: '20px solid #4A90E2',
			borderRadius: '0 8px 0 0',
		},
	},
	newTopContainer: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		marginBottom: 8,
	},
	newInfoContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	newBadge: {
		fontSize: 14,
		color: '#E91E63',
		fontWeight: 600,
	},
	newInfoIcon: {
		width: 16,
		height: 16,
		opacity: 0.6,
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		':hover': {
			opacity: 1,
		},
	},
	newHeaderContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 8,
		marginBottom: 8,
	},
	newTitleContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 4,
	},
	newTitleButton: {
		textAlign: 'left',
		background: 'none',
		border: 'none',
		padding: 0,
		cursor: 'pointer',
		fontSize: 16,
		fontWeight: 600,
		color: brandPrimaryText,
		lineHeight: 1.5,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		// @ts-expect-error - aphrodite doesn't support webkit box
		display: '-webkit-box',
		webkitBoxOrient: 'vertical',
		webkitLineClamp: 2,
		wordWrap: 'break-word',
		minHeight: '3em',
		maxHeight: '3em',
		':hover': {
			color: brandPrimaryText,
		},
	},
	newContentContainer: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 8,
	},
	newContentText: {
		background: 'transparent !important',
		color: `${gray3} !important`,
		fontFamily: 'Sora !important',
		fontSize: 12,
		margin: 0,
		padding: 0,
		lineHeight: '1.4',
		overflow: 'hidden',
		display: '-webkit-box' as any,
		'-webkit-line-clamp': 2 as any,
		'-webkit-box-orient': 'vertical' as any,
		textOverflow: 'ellipsis',
		maxHeight: '2.8em',
	},
	newTooltipContent: {
		maxWidth: '200px',
		whiteSpace: 'normal',
		wordWrap: 'break-word',
		hyphens: 'auto',
	},
	// Modern styles matching the new CampaignTemplateCard design
	modernCardContainer: {
		alignItems: 'stretch',
		background: white,
		border: `1px solid ${antiFlashWhite}`,
		borderRadius: 8,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		padding: 12,
		position: 'relative',
		transition: 'box-shadow 0.2s ease, transform 0.2s ease',
		marginRight: 8,
		':hover': {
			boxShadow: '0px 4px 16px rgba(139, 139, 139, 0.12)',
			transform: 'translateY(-1px)',
		},
	},
	modernTopContainer: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
	},
	modernInfoContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.md,
	},
	modernNewBadge: {
		fontSize: 14,
		color: THEME.colors.tertiary.main,
		fontWeight: 600,
	},
	modernInfoIcon: {
		width: 16,
		height: 16,
		opacity: 0.6,
		cursor: 'pointer',
		color: '#4A90E2',
		':hover': {
			opacity: 1,
		},
	},
	modernHeaderContainer: {
		alignItems: 'flex-start',
		display: 'flex',
		gap: 8,
		justifyContent: 'space-between',
	},
	modernTitleContainer: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		gap: 4,
		minWidth: 0,
	},
	modernTitleButton: {
		textAlign: 'left',
		background: 'none',
		border: 'none',
		padding: 0,
		cursor: 'pointer',
		fontSize: 16,
		fontWeight: 600,
		color: brandPrimaryText,
		lineHeight: 1.5,
		height: 'fit-content',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		// @ts-expect-error - aphrodite doesn't support webkit box
		display: '-webkit-box',
		WebkitBoxOrient: 'vertical',
		WebkitLineClamp: 2,
		// Use word-wrap to prevent cutoff
		wordWrap: 'break-word',
		// Height for 2 lines with proper spacing

		':hover': {
			color: brandPrimaryText,
		},
	},
	modernContentContainer: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
	},
	modernContentText: {
		background: 'transparent !important',
		color: `${gray3} !important`,
		fontFamily: 'Sora !important',
		fontSize: 12,
		margin: 0,
		padding: 0,
		lineHeight: '1.4',
		overflow: 'hidden',
		display: '-webkit-box' as any,
		'-webkit-line-clamp': 2 as any,
		'-webkit-box-orient': 'vertical' as any,
		textOverflow: 'ellipsis',
		maxHeight: '2.8em',
	},
	modernTooltipContent: {
		maxWidth: 200,
		whiteSpace: 'normal',
		wordWrap: 'break-word',
		hyphens: 'auto',
	},
});

export const campaignTemplateCardStyleSheet = StyleSheet.create({
	body: {
		background: 'transparent !important',
		color: '#3F3F3F !important',
		fontFamily: 'Sora !important',
		fontSize: '14px !important',
	},

	button: {
		background: 'none',
		marginTop: 20,
		maxWidth: 145,
		width: 145,
	},
	buttonStack: {
		justifyContent: 'space-between',
	},
	cardText: {
		background: 'transparent !important',
		color: 'titles !important',
		fontFamily: 'Sora !important',
		fontSize: '14px !important',
		paddingTop: 12,
		...CssSelectors.allDescendants({
			background: 'transparent !important',
			color: 'black !important',
			fontFamily: 'Sora !important',
			fontSize: '14px !important',
			height: 28,
			margin: 0,
		}),
	},
	container: {
		alignItems: 'stretch',
		background: white,
		border: `1px solid ${antiFlashWhite}`,
		borderRadius: 6,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.100034)',
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		paddingBottom: 30,
		paddingLeft: 30,
		position: 'relative',
		...CssSelectors.allDescendants(
			{
				border: `1px dashed ${brandSecondary}`,
				borderRadius: 3,
				boxSizing: 'border-box',
				fontSize: 14,
				padding: '1px 5px',
			},
			'span[data-placeholder="true"]'
		),
	},
	smallContainer: {
		padding: 16,
	},
	featured: {
		background: 'linear-gradient(156.83deg, #F5FAFD 14.57%, #E8F3F9 42%, #E8F3F9 85.02%)',
	},
	flagHighlight: {
		marginTop: 50,
	},
	headerContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		paddingBottom: 2,
	},
	menu: {
		position: 'absolute',
		right: 5,
		top: 5,
		width: 30,
	},
	nameContainer: {
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',
		gap: 8,
		alignItems: 'center',
		fontSize: 16,
		overflow: 'hidden',
		paddingTop: 30,
		textOverflow: 'ellipsis',
		width: '100%',
		...CssSelectors.allChildren(
			{
				maxWidth: '100%',
			},
			'div'
		),
	},
	nameContainerMedium: {
		color: brandPrimaryText,
	},
	nameContainerSmall: {
		color: brandPrimaryText,
		fontSize: 14,
		paddingTop: 0,
	},
	newItem: {
		color: emailActivityTintColor,
	},
	noPaddingTop: {
		paddingTop: 0,
	},
	openLetter: {
		height: 82,
		position: 'absolute',
		right: -10,
		top: -10,
		transform: 'translate3d(0px, -10px, 0)',
	},
	popover: {
		borderBottomRightRadius: 0,
		boxSizing: 'border-box',
		color: '#4A4A4A',
		fontSize: 12,
		lineHeight: '18px',
		marginLeft: 14,
		maxWidth: 240,
		padding: '6px 6px 6px 6px',
	},
	popoverAnchor: {
		zIndex: 5,
		top: 0,
		right: 0,
	},
	popoverContainer: {
		marginRight: 25,
	},
	reviewed: {
		color: '#89C947',
		marginRight: 20,
	},
	reviewedStack: {
		marginTop: 20,
		...Layouts.horizontalStack(1),
	},
	sendNow: {
		height: 82,
		left: 45,
		position: 'absolute',
		top: -5,
		transform: 'translate3d(-52px, -15px, 0px)',
	},
	sharedBy: {
		fontSize: 11,
		fontStyle: 'italic',
	},
	textContainer: {
		minHeight: 64,
	},
	textContainerSmall: {
		minHeight: 0,
	},
	textContent: {
		color: '#3F3F3F !important',
		fontFamily: 'Sora !important',
		fontSize: '14px !important',
		marginBottom: 0,
		marginTop: 0,
		paddingBottom: 0,
		paddingRight: 20,
		paddingTop: 12,
	},
	textContentSmall: {
		fontSize: '12px !important',
		height: 'auto',
	},
});
